import { useObservable } from 'react-use'
import { BehaviorSubject, Subject, scan } from 'rxjs'

export const $refreshContent = new Subject<number>()
export const forceRefreshContent = () => $refreshContent.next(Math.random())
export const $refreshCount = $refreshContent.pipe(scan((a, b) => a + b, 0))
export const useRefreshCount = () => useObservable($refreshCount, 0)

export const $globalSearching = new BehaviorSubject(false)
export const useGlobalSearching = () => useObservable($globalSearching, false)
